import Vue from 'vue'
import InfiniteLoading from 'vue-infinite-loading'
import { mapActions, mapState } from 'vuex'
import responseMixin from '@/mixins/responseMixin'
import unreadMessagesBlinkTitleMixin from '@/mixins/unreadMessagesBlinkTitleMixin'
import JobActiveCardCustomer from '@/partials/JobCards/JobActiveCardCustomer/JobActiveCardCustomer.vue'

const OFFERS_LIMIT = 20

export default Vue.extend<any, any, any>({
  mixins: [responseMixin, unreadMessagesBlinkTitleMixin],
  components: {
    JobActiveCardCustomer,
    InfiniteLoading,
  },
  data() {
    return {
      infiniteId: 0,
      totalLoading: false,
    }
  },
  computed: {
    ...mapState({
      jobs: (state: any) => state.myJobs.clientActive.values,
      isLoading: (state: any) => state.myJobs.clientActive.isLoading,
      isLoaded: (state: any) => state.myJobs.clientActive.isLoaded,
      pagination: (state: any) => state.myJobs.clientActive.pagination,
    }),
  },
  async created() {
    await this.load({ limit: OFFERS_LIMIT, offset: 0 })
    this.infiniteId = +new Date()
  },
  methods: {
    ...mapActions({
      load: 'myJobs/loadClientActive',
      loadMore: 'myJobs/loadMoreClientActive',
    }),
    async onLoadMore($state: any) {
      try {
        if (this.jobs.length < this.pagination.total) {
          this.totalLoading = true
          await this.loadMore({ limit: OFFERS_LIMIT, offset: this.jobs.length })
          return $state.loaded()
        }
        return $state.complete()
      } catch (e) {
        this.parseError(e)
      } finally {
        this.totalLoading = false
      }
    },
    async onResetJobs() {
      await this.load({ limit: OFFERS_LIMIT, offset: 0 })
      this.infiniteId = +new Date()
    },
  },
  metaInfo() {
    return {
      title: this.getMetaTitle('My Jobs - In Progress'),
    }
  },
})
